export const genders = [
    {id: 1, label: "ds_gender_1"},
    {id: 2, label: "ds_gender_2"},
    {id: 0, label: "ds_gender_0"},
];
